// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SCcf9IA{display:flex;align-items:center;gap:.5em}@media(max-width: 899px){.SCcf9IA{gap:.25em}}.Pu4ATqj{width:1em;min-width:1em;height:1em;font-size:16px}.LUElZSo,.SCcf9IA .LUElZSo{position:relative;overflow:hidden;line-height:21px;white-space:nowrap;text-overflow:ellipsis;color:#576875}@media(max-width: 899px){.LUElZSo,.SCcf9IA .LUElZSo{font-size:12px;line-height:15px}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SCcf9IA`,
	"icon": `Pu4ATqj`,
	"title": `LUElZSo`
};
export default ___CSS_LOADER_EXPORT___;
